import Marquee from "react-fast-marquee";
import { useLanguage } from "../context/LanguageContext";
import { copy } from "../data/content";

export const EditorialMarquee = () => {
  const { t } = useLanguage();
  const text = t(copy.marquee);

  return (
    <div
      data-testid="marquee"
      className="border-y border-[#E5E5E5] bg-[#F2F2F0] py-8 md:py-12 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        <span className="inline-block font-['Cormorant_Garamond'] italic text-3xl md:text-5xl leading-[1.4] text-[#111111] mr-6 pb-1">
          {text}
        </span>
      </Marquee>
    </div>
  );
};
